export default "/fonts/vendor/@coreui/icons/CoreUI-Icons-Free.svg?056d65c989aa546ec057f2bf71ff9ea3";